/* Premium Islamic Watches — Theme JS */

(function () {
  'use strict';

  // Reveal on scroll
  if ('IntersectionObserver' in window) {
    const reveal = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          reveal.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });

    document.querySelectorAll('.iw-reveal').forEach(function (el) {
      reveal.observe(el);
    });
  } else {
    document.querySelectorAll('.iw-reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  // FAQ accordion
  document.querySelectorAll('.iw-faq__item').forEach(function (item) {
    const trigger = item.querySelector('.iw-faq__question');
    if (!trigger) return;
    trigger.addEventListener('click', function () {
      const isOpen = item.classList.contains('is-open');
      // Optionally close siblings:
      item.parentElement.querySelectorAll('.iw-faq__item.is-open').forEach(function (other) {
        if (other !== item) other.classList.remove('is-open');
      });
      item.classList.toggle('is-open', !isOpen);
    });
  });

  // Mobile menu (simple toggle)
  const menuToggle = document.querySelector('.iw-header__menu-toggle');
  const nav = document.querySelector('.iw-header__nav');
  if (menuToggle && nav) {
    menuToggle.addEventListener('click', function () {
      nav.classList.toggle('is-open');
    });
  }
})();
